import { IOnGoingTrip } from "@types";

export const getTripStatus = (detail?: IOnGoingTrip | null): string => {
  if (!detail) return "NOTSTARTED";

  const isNotStarted = detail.tripStatusNow === "NOTSTARTED";
  const hasPolyline = detail.polyline && detail.polyline.length > 0;

  if (isNotStarted && hasPolyline) return "PAUSED";
  if (isNotStarted && !hasPolyline) return "NOTSTARTED";
  
  return detail.tripStatusNow || "NOTSTARTED";
};

export const getRouteStatus = (detail?: IOnGoingTrip | null, statusRouteNow?: string): string => {
  if (statusRouteNow) return statusRouteNow;
  
  if (!detail) return "NOTSTARTED";
  
  const isNotStarted = detail.tripStatusNow === "NOTSTARTED";
  const hasNoPolyline = !detail.polyline?.length;
  
  if (isNotStarted && hasNoPolyline) return "NOTSTARTED";
  
  return detail.routeStatusNow || "NOTSTARTED";
};